import Button, { ButtonProps } from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { useMemo } from "react";
import { Dialog } from "../../../components/Dialog";
import { Autocomplete } from "../../../components/Autocomplete";

//assets
import NoBackground from "../../../assets/background/no-img.png";

type DialogNewBackgroudProps = {
  open: boolean;
  onClose: () => void;
};

export function DialogNewBackgroud({ onClose, open }: DialogNewBackgroudProps) {
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Cancelar",
        onClick: onClose,
      },
      {
        children: "Salvar",
        variant: "contained",
      },
    ];
  }, [onClose]);

  return (
    <Dialog maxWidth="md" fullWidth open={open} actions={actions}>
      <Stack spacing={4} direction="row">
        <Stack spacing={1}>
          <img alt="img-background" src={NoBackground} />
          <Button variant="outlined">Importar fundo</Button>
        </Stack>
        <Stack spacing={2}>
          <Typography variant="h6">
            Adicione um fundo do seu computador
          </Typography>
          <Typography>
            Adicione informações do seu fundo para encontrá-las mais facilmente.
          </Typography>
          <Autocomplete
            fullWidth
            size="small"
            label="Formatos"
            options={[]}
            getOptionLabel={(option) => option.name}
            helperText="Seu fundo aparecerá no formato que você salvar"
          />

          <TextField size="small" label="Nome do fundo" />
        </Stack>
      </Stack>
    </Dialog>
  );
}
